import React, { useState } from "react";
import {
  View,
  TextInput,
  FlatList,
  Text,
  ActivityIndicator,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
} from "react-native";
import { useDebounce } from "use-debounce";

import { useInfiniteQuery } from "@tanstack/react-query";
import axios from "axios";
import Colors from "../../../Resources/Color";
import { useTranslation } from "react-i18next";
import { useDevice, useScreenDimensions } from "../../_layout";
import SearchBar from "../../Components/SearchBar";
import CTAButton from "../../Components/CTAButton";
import GlobalStyles from "../../../Resources/Styles";
import AddCustomFoodView from "./AddCustomFoodView";
import { observer, Observer } from "mobx-react";
import { FontAwesome } from "@expo/vector-icons";
import Ionicons from "@expo/vector-icons/Ionicons";
import CustomAlert from "../../Components/CustomAlert";

const CoachFoodLibrary = ({ coach }) => {
  const { t, i18n } = useTranslation();
  const { screenSize } = useScreenDimensions();
  const { isMobile } = useDevice();

  const [text, setText] = useState("");

  const [showingAddCustomFood, setShowingAddCustomFood] = useState(false);

  const [showingEditFood, setShowingEditFood] = useState(false);

  const FoodsTable = observer(() => {
    const TableHeader = () => {
      return (
        <View
          style={{
            marginTop: screenSize === "small" ? 8 : 12,
            backgroundColor: Colors.lightGrayColor,
            height: 48,
            borderTopLeftRadius: 14,
            borderTopRightRadius: 14,
            borderWidth: 0.1,
            borderColor: Colors.borderColor,
            alignItems: "center",
          }}
        >
          <View
            style={{
              ...GlobalStyles.HStack,
              width: "100%",
              flex: 1,
              height: "100%",
              // justifyContent: "space-between",
              justifyContent: "flex-start",
              paddingHorizontal: 10,
            }}
          >
            {[
              { key: "name", label: t("name-string"), width: "35%" },
              // {
              //   key: "quantity",
              //   label: t("quantity-string"),
              //   width: "10%",
              // },
              {
                key: "calories",
                label: t("calories-string"),
                width: "15%",
              },
              { key: "carbs", label: t("carbs-string"), width: "15%" },
              {
                key: "protein",
                label: t("protein-string"),
                width: "15%",
              },
              {
                key: "fats",
                label: t("fats-string"),
                width: "15%",
              },
            ].map(({ key, label, width }) => (
              <TouchableOpacity
                key={key}
                onPress={() => coach.setProperty("sortTerm", key)}
                style={{
                  width,
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Text
                  style={{
                    textAlign: "center",
                    fontSize: 14,
                    fontWeight: "600",
                    color: "rgb(108, 115, 127)",
                  }}
                >
                  {label}
                </Text>
              </TouchableOpacity>
            ))}
          </View>
        </View>
      );
    };

    const FoodRowView = ({ food, index }) => {
      const [showingDeleteAlert, setShowingDeleteAlert] = useState(false);
      const deleteAlertTitle = "deleteCoachFoodAlertTitle-string";
      const deleteAlertText = "deleteCoachFoodAlertText-string";

      const deleteFood = () => {
        coach.updateCoachDeletionFoods(food.id);
        coach.startOrResetBatchTimer();

        coach.setProperty(
          "foods",
          (coach.foods = coach.foods.filter((f) => f.id !== food.id))
        );
      };

      const DeleteFoodButton = () => {
        const [isHovered, setIsHovered] = useState(false);

        return (
          <TouchableOpacity
            onPress={() => {
              setShowingDeleteAlert(true);
            }}
            onMouseEnter={() => !isMobile && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={{
              width: "5%",
            }}
          >
            <Ionicons
              name={isHovered ? "trash" : "trash-outline"}
              size={20}
              color={"red"}
              // style={{
              //   paddingLeft: 8,
              // }}
            />
          </TouchableOpacity>
        );
      };

      return (
        <View
          style={{
            backgroundColor: "white",
            height: 48,
            borderBottomRightRadius: index === coach.foods.length - 1 ? 14 : 0,
            borderBottomLeftRadius: index === coach.foods.length - 1 ? 14 : 0,
            borderTopWidth: index === 0 ? 0 : 0.1,
            borderRightWidth: 0.1,
            borderLeftWidth: 0.1,
            borderBottomWidth: index === coach.foods.length - 1 ? 0.1 : 0,
            borderColor: Colors.borderColor,
            alignItems: "center",
          }}
        >
          <View
            style={{
              ...GlobalStyles.HStack,
              width: "100%",
              flex: 1,
              height: "100%",
              // justifyContent: "space-between",
              justifyContent: "flex-start",
              paddingHorizontal: 10,
            }}
          >
            {[
              { key: "name", property: "name", unit: "", width: "35%" },
              {
                key: "calories",
                property: "calories",
                unit: "kcal",
                width: "15%",
              },
              { key: "carbs", property: "carbs", unit: "g", width: "15%" },
              {
                key: "protein",
                property: "protein",
                unit: "g",
                width: "15%",
              },
              {
                key: "fats",
                property: "fats",
                unit: "g",
                width: "15%",
              },
            ].map(({ key, property, unit, width }) => (
              <TouchableOpacity
                key={key}
                style={{
                  width,
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onPress={() => {
                  coach.setSelectedFood(food);
                  setShowingEditFood(true);
                }}
              >
                <Text
                  style={{
                    textAlign: "center",
                    fontSize: 14,
                    fontWeight: "600",
                    color: "rgb(108, 115, 127)",
                  }}
                >
                  {food.getProperty(property)}
                  {unit != "" ? ` ${unit}` : ""}
                </Text>
              </TouchableOpacity>
            ))}
            <DeleteFoodButton />
          </View>

          {showingDeleteAlert && (
            <CustomAlert
              isVisible={showingDeleteAlert}
              onClose={() => setShowingDeleteAlert(false)}
              title={deleteAlertTitle}
              text={deleteAlertText}
              action={deleteFood}
              specialCTA={"delete-string"}
            />
          )}
        </View>
      );
    };

    return (
      coach &&
      coach.foods.length > 0 && (
        <ScrollView
          horizontal={true}
          style={{
            width: "100%",
            flexDirection: "row",
          }}
          contentContainerStyle={{ flex: 1 }}
          showsHorizontalScrollIndicator={false}
        >
          <View
            style={{
              minWidth: 800,
              flex: 1,
              width: "100%",
              // width: 800,
            }}
          >
            <TableHeader />
            {coach.foods.map((food, idx) => (
              <FoodRowView food={food} index={idx} key={idx} />
            ))}
          </View>
        </ScrollView>
      )
    );
  });

  return (
    <View
      style={{
        flex: 1,
        backgroundColor: Colors.backgroundColor,
        marginTop: screenSize === "small" ? 16 : 24,
        // justifyContent: "flex-start",
        minWidth: coach.foods > 0 ? 800 : undefined,
      }}
    >
      <View
        style={[GlobalStyles.HStack, { marginBottom: 16, maxWidth: "60%" }]}
      >
        <SearchBar
          text={text}
          onChangeText={(text) => setText(text)}
          placeholder={t("search-string")}
        />

        <CTAButton
          plus={true}
          text={t("newFood-string")}
          action={() => {
            // client.initAuxNutritionPlan();
            setShowingAddCustomFood(true);
          }}
          disabled={false}
        />
      </View>

      {/* {coach && coach.foods > 0 && (
        <ScrollView
          horizontal={true}
          style={{
            width: "100%",
            flexDirection: "row",
          }}
          contentContainerStyle={{ flex: 1 }}
          showsHorizontalScrollIndicator={false}
        >
          <View
            style={{
              minWidth: 800,
              flex: 1,
              width: "100%",
              // maxWidth: "100%",
              // borderWidth: 2,
            }}
          >
            <TableHeader />
            {coach.foods.map((food, idx) => (
              <Text
                key={idx}
                onPress={() => {
                  coach.setSelectedFood(food);
                  setShowingEditFood(true);
                  console.log(food);
                }}
              >
                {food.name}
              </Text>
            ))}
          </View>
        </ScrollView>
      )} */}

      <FoodsTable />

      {showingAddCustomFood && coach && (
        <AddCustomFoodView
          isVisible={showingAddCustomFood}
          onClose={() => setShowingAddCustomFood(false)}
          coach={coach}
        />
      )}

      {showingEditFood && coach && coach.selectedFood && (
        <AddCustomFoodView
          isVisible={showingEditFood}
          onClose={() => setShowingEditFood(false)}
          coach={coach}
          food={coach.selectedFood}
        />
      )}
    </View>
  );
};

export default CoachFoodLibrary;
